import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Typography, Box, Card, List, ListItemButton, ListItemText, Breadcrumbs, Link } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { axiosInstance } from "../component/Api/instance";
import { UserContext } from "../Context";
import { PrimaryButton } from "../component/ui/Buttons";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DescriptionIcon from "@mui/icons-material/Description";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CrownIcon from "../asserts/crown.png";

const InstructionPageContainer = styled(Box)(({ theme }) => ({
  minHeight: "85vh",
  padding: "32px 0",
  backgroundColor: theme.palette.background.default,
}));

const SidebarCard = styled(Card)(({ theme }) => ({
  borderRadius: "24px",
  padding: "24px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
}));

const InstructionDetailsCard = styled(Card)(({ theme }) => ({
  borderRadius: "24px",
  padding: "40px",
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  minHeight: "450px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    padding: "24px",
  },
}));

const PaperItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'selected'
})(({ theme, selected }) => ({
  borderRadius: "14px",
  marginBottom: "8px",
  padding: "12px 16px",
  backgroundColor: selected ? `${theme.palette.primary.main}0D` : "transparent",
  border: `1px solid ${selected ? theme.palette.primary.main : 'transparent'}`,
  color: selected ? theme.palette.primary.main : theme.palette.text.primary,
  fontWeight: selected ? 700 : 500,
  transition: "all 0.15s ease",
  "&:hover": {
    backgroundColor: selected ? `${theme.palette.primary.main}1A` : theme.palette.action.hover,
  },
}));

export default function MainsInstruction() {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [data, setData] = useState([]);
  const [paperid, setPaperid] = useState(null);
  const { sno } = useParams();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [category, setCategory] = useState([]);
  const plan = localStorage.getItem("category");
  const email = localStorage.getItem("userMail");
  const { Endpoint } = useContext(UserContext);

  useEffect(() => {
    Institution();
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(`get/U_ViewProfile.php`, {
        email: email,
      });
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
        }
        setCategory(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const Institution = async () => {
    try {
      const response = await axiosInstance.post(`get/U_ViewMains.php`, {
        userId: email,
      });
      if (response.status === 200) {
        if (response.data.message === "timeout") {
          navigate("/signin");
        }
        const yearobj = response.data
          ?.map((item) => ({
            ...item,
            img: `${Endpoint}/controllers/api/admin/upload/${item.img}`,
          }))
          .filter((item) => item.sno == sno);
        setData(yearobj);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchPaperData = async () => {
      try {
        const response = await axiosInstance.post(`get/U_ViewMainsPaper.php`, {
          userId: email,
          id: sno,
        });
        if (response.status === 200) {
          if (response.data.message === "timeout") {
            navigate("/signin");
          }
          const paperobj = response?.data?.filter(
            (datas) => datas.mains_id == sno
          );
          setOptions(paperobj);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchPaperData();
  }, []);

  const PaperData = async (index, paperCategory) => {
    const selectedPaper = options[index];

    if (category.length > 0 && options.length > 0) {
      if (plan === "standard" && paperCategory != "premium") {
        try {
          const response = await axiosInstance.post(`post/U_MainsTest.php`, {
            id: email,
            mains_id: sno,
            paper_id: selectedPaper.sno,
          });
          if (response.status === 200) {
            if (response.data.message === "timeout") {
              navigate("/signin");
            }
            setSelectedIndex(index);
            setPaperid(selectedPaper.sno);
          }
        } catch (error) {
          console.error("Error initializing paper:", error);
        }
      } else if (plan == "premium") {
        try {
          const response = await axiosInstance.post(`post/U_MainsTest.php`, {
            id: email,
            mains_id: sno,
            paper_id: selectedPaper.sno,
          });
          if (response.status === 200) {
            if (response.data.message === "timeout") {
              navigate("/signin");
            }
            setSelectedIndex(index);
            setPaperid(selectedPaper.sno);
          }
        } catch (error) {
          console.error("Error initializing paper:", error);
        }
      } else {
        alert("Please subscribe to continue premium ");
        navigate("/plan");
      }
    } else {
      alert("Data is not available to determine access.");
    }
  };

  const startTest = () => {
    if (paperid) {
      const selectedPaper = options[selectedIndex];
      navigate(`/mainstest/${sno}/${paperid}`, {
        state: {
          paperName: selectedPaper.paper_name,
        },
      });
    }
  };

  return (
    <InstructionPageContainer>
      <Container>
        <Breadcrumbs aria-label="breadcrumb" style={{ marginBottom: "24px" }}>
          <Link underline="hover" color="inherit" href="" onClick={(e) => { e.preventDefault(); navigate("/home"); }}>
            Home
          </Link>
          <Link underline="hover" color="inherit" href="" onClick={(e) => { e.preventDefault(); navigate("/mains"); }}>
            AIIMS Mains
          </Link>
          <Typography color="text.primary">Instructions</Typography>
        </Breadcrumbs>

        {data.length > 0 &&
          data.map((d) => (
            <Box key={d.sno}>
              <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "32px", flexWrap: "wrap", gap: "16px" }}>
                <Box>
                  <Typography variant="h1" style={{ fontWeight: 800 }}>
                    {d.mains_name}
                  </Typography>
                  <Typography variant="body1" color="textSecondary" style={{ marginTop: "4px" }}>
                    {d.mains_desc}
                  </Typography>
                </Box>
                {d.img && (
                  <img
                    src={d.img}
                    alt="Mains Logo"
                    style={{ maxHeight: "65px", objectFit: "contain", borderRadius: "12px" }}
                  />
                )}
              </Box>

              <Row className="g-4">
                <Col xs={12} md={4} lg={3}>
                  <SidebarCard>
                    <Box style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px", color: "var(--color-primary)" }}>
                      <CalendarMonthIcon />
                      <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                        Select Exam Paper
                      </Typography>
                    </Box>

                    {options.length === 0 ? (
                      <Typography variant="body2" color="textSecondary">
                        No paper options found.
                      </Typography>
                    ) : (
                      <List style={{ padding: 0 }}>
                        {options.map((option, index) => (
                          <PaperItemButton
                            key={index}
                            selected={selectedIndex === index}
                            onClick={() => PaperData(index, option.category)}
                          >
                            <ListItemText 
                              primary={
                                <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                  <Typography style={{ fontWeight: selectedIndex === index ? 700 : 500, fontSize: "0.9rem" }}>
                                    {option.paper_name}
                                  </Typography>
                                  {option.category === "premium" && (
                                    <img src={CrownIcon} height="16px" alt="Crown" />
                                  )}
                                </Box>
                              }
                            />
                          </PaperItemButton>
                        ))}
                      </List>
                    )}
                  </SidebarCard>
                </Col>

                <Col xs={12} md={8} lg={9}>
                  <InstructionDetailsCard>
                    <Box>
                      <Box style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "24px" }}>
                        <DescriptionIcon color="primary" />
                        <Typography variant="h2" style={{ fontWeight: 800 }}>
                          Candidate Instructions
                        </Typography>
                      </Box>

                      <Box style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                        {d.mains_instruction ? (
                          d.mains_instruction
                            .split(/\r?\n/)
                            .filter((instruction) => instruction.trim() !== "")
                            .map((instruction, index) => (
                              <Box key={index} style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                                <Box style={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: "22px", height: "22px", borderRadius: "50%", backgroundColor: "rgba(30, 58, 138, 0.08)", color: "var(--color-primary)", fontWeight: 700, fontSize: "0.75rem", marginTop: "2px" }}>
                                  {index + 1}
                                </Box>
                                <Typography variant="body1" color="textPrimary" style={{ lineHeight: 1.6 }}>
                                  {instruction.trim()}
                                </Typography>
                              </Box>
                            ))
                        ) : (
                          <Typography variant="body1" color="textSecondary">
                            No instructions specified.
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    <Box style={{ display: "flex", justifyContent: "flex-end", marginTop: "40px" }}>
                      {selectedIndex !== null ? (
                        <PrimaryButton
                          onClick={startTest}
                          endIcon={<ArrowForwardIcon />}
                          style={{ height: "46px", borderRadius: "14px", minWidth: "150px" }}
                          disabled={!paperid}
                        >
                          Start Exam
                        </PrimaryButton>
                      ) : (
                        <Box style={{ display: "flex", alignItems: "center", gap: "8px", color: "var(--color-text-secondary)" }}>
                          <HelpOutlineIcon fontSize="small" />
                          <Typography variant="body2">
                            Please select an exam paper from the left panel to begin.
                        </Typography>
                        </Box>
                      )}
                    </Box>
                  </InstructionDetailsCard>
                </Col>
              </Row>
            </Box>
          ))}
      </Container>
    </InstructionPageContainer>
  );
}
